/**
 * Created by jackzdhqq.com on 2017/5/15.
 */
const state = {
  state: {
    id: 0
  }
};
const getters = {
  getPassID: state => {
    return state.id;
  }
};
const mutations = {
  passValue (state, payload) {
    state.id = payload.id;
    console.log(state.id);
  }
};
export default {
  state,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/passValue.js